export default "__VITE_ASSET__B5JrJ6TB__"